import Vue from 'vue'
import Router from 'vue-router'
import ActivityRouters from './activityRouters'
import SystemRouters from './systemRouters'
import ProtocolRouters from './protocolRouters'
import MemberRouters from './memberRouters'
import YjhRouters from './yjhRouters'
import YjbRouters from './yjbRouters'
import AdvRouters from './advRouters'
import DownloadRouters from './downloadRouters'
import DownloadYhhRouters from './downloadYhhRouters'
import XbdRouters from './dsRouters'
import JkhRouters from './jkhRouters'
import BybRouters from './bybRouters'
import ThhRouters from './thhRouters'
import YskhRouters from './yskhRouters'
import DialogAuth from '@/pages/auth/dialog'
import { getLocalData, setInterceptBack } from '@/config/utils'
import { openMinProgram } from '@/config/wx-min-program'
import store from '@/store'
import { handleMatchStartPageScene, handleMatchEndPageScene, handleResetVideoRecordInstance, handleStartVideoRecord } from '@/config/video-record'
import { isMiniProgramCode } from '@/config/constants'
import { hasChannelH5Return, redirectToChannelH5Return } from '@/config/channel-h5-return'
import { getBaseStartPathname } from '@/config/app-base-path'

Vue.use(Router)

const routes = [
  ...YskhRouters, // 易速可花iOS
  ...ThhRouters, // 拓花花iOS
  ...BybRouters, // 易花花极速版iOS
  ...JkhRouters, // 金可花iOS
  ...XbdRouters, // 信保达iOS
  ...DownloadYhhRouters, // 易花花运营下载落地页路由
  ...DownloadRouters, // 运营下载落地页路由
  ...AdvRouters, // 广告业务路由
  ...ActivityRouters, // 活动路由
  ...SystemRouters, // 系统路由
  ...ProtocolRouters, // 协议路由
  ...MemberRouters, // 会员相关路由
  ...YjhRouters, // 乐易花路由
  ...YjbRouters // 易借宝路由
]

const router = new Router({
  base: `${getBaseStartPathname()}/`,
  mode: 'history',
  routes,
  scrollBehavior: () => ({ y: 0 }),
  strict: process.env.NODE_ENV !== 'production'
})

var nowRoute

router.beforeEach((to, from, next) => {
  // 共享页面可能直接跳易借首页；渠道会话直接解析安全地址并返回合作方。
  if (to.name === 'home_index' && hasChannelH5Return()) {
    redirectToChannelH5Return(router)
    next(false)
    return
  }
  const lzCode = getLocalData('lzCode')
  if (handleMatchStartPageScene(to.path, from.path)) {
    handleStartVideoRecord()
  } else if (handleMatchEndPageScene(from.path, to.path)) {
    handleResetVideoRecordInstance()
  }
  if (to.path === '/index') {
    if (isMiniProgramCode(lzCode)) {
      openMinProgram()
      next(false)
      return
    } else if (['CJTG_JDJR_LZ'].includes(lzCode)) {
      next('/home/jd')
      return
    } else if (['CJTG_RSDKFZ_LZ'].includes(lzCode)) {
      // 路由守卫没有组件实例，直接读取联登持久化的渠道扩展参数完成外部回跳。
      const tempExtendParams = getLocalData('extendParamsData') || {}
      const tempReturnFailUrl = tempExtendParams.channelH5 && tempExtendParams.channelH5.returnFailUrl
      if (tempReturnFailUrl) {
        window.location.href = tempReturnFailUrl
        next(false)
        return
      }
      next()
      return
    } else if (localStorage.getItem('is_half_process')) {
      next('/home/yjsd')
      return
    } else if (localStorage.getItem('is_half_sms')) {
      next({
        path: '/su-niu/home',
        query: { cnl: getLocalData('lzCode') }
      })
      return
    } else if (lzCode && lzCode.includes('CJTG_')) {
      next()
      return
    } else {
      if (process.env.NODE_ENV !== 'development') {
        return store.dispatch('native', { type: '跳首页' }).then(() => {
          next(false)
        }).catch(() => {
          next()
        })
      }
    }
  }
  window.curElement = '&lt;body&gt;&lt;/body&gt;'
  if (to.meta.title) { // 路由发生变化修改页面title
    document.title = to.meta.title
  }
  if (nowRoute && nowRoute.meta.interceptBack && window.vm.$nextTick && nowRoute.meta.interceptLock) {
    from.meta.title && (document.title = from.meta.title)
    next(false)
    window.vm.$nextTick(() => {
      DialogAuth({ path: from.meta.code })
    })
  } else {
    if (!nowRoute || (nowRoute && nowRoute.name !== to.name)) {
      nowRoute = to
    }
    next()
  }
  if (nowRoute && nowRoute.meta.interceptLock === false) {
    setInterceptBack()
  }
})

export default router
